import { RenderRoadCardProps, RenderRoadSearchErrorCardProps } from "entities/shared/roadCard.types";
import { ShipmentType } from "entities/shared/shipmentCard.types";
import { ValueOf } from "shared/lib/typeCheck.lib";

import { RoadSearchCardModel } from "../model/model";

type RoadSearchCardProps = {
  data: RoadSearchCardModel;
  shipmentType: ValueOf<typeof ShipmentType>;
  className?: string;
  openCard: (data: RoadSearchCardModel) => void;
  deleteCardHandler: (card: RoadSearchCardModel) => void;
  renderCard: (props: RenderRoadCardProps) => JSX.Element;
  renderErrorCard: (props: RenderRoadSearchErrorCardProps) => JSX.Element;
};

export const RoadSearchCard: RFC<RoadSearchCardProps> = ({
  data,
  shipmentType,
  openCard,
  deleteCardHandler,
  renderCard,
  renderErrorCard,
}) => {
  const onDeleteHandler = () => deleteCardHandler(data);

  const onOpenHandler = () => {
    openCard(data);
  };

  const errorText = "";

  if (errorText) {
    return renderErrorCard({
      text: errorText,
      status: "error",
      reference: data.reference,
      onDelete: onDeleteHandler,
    });
  }

  return renderCard({
    shipmentType,
    ata: data.ata,
    atd: data.atd,
    eta: data.eta,
    etd: data.etd,
    reference: data.reference,
    status: data.status,
    pieces: data.pieces,
    carrierName: data.carrierName,
    scac: data.scac,
    directionFrom: data.fromDirection,
    directionTo: data.toDirection,
    progressLine: { status: "location-data", percent: data.progress, rotation: "horizontal" },
    onOpen: onOpenHandler,
    onDelete: onDeleteHandler,
  });
};
